import ApiClient from "../api-client";
import { EnvType } from "../services";
import { LoginOktaRequest } from "../Types/login-okta-request";
import { LoginOktaResponse } from "../Types/login-okta-response";
import { default as IOktaApiClient, default as OktaApiClient } from "./okta-api-client";

export default class OktaService {
  oktaApiClient: IOktaApiClient;

  constructor(envType: EnvType) {
    this.oktaApiClient = new OktaApiClient(new ApiClient(envType), envType);
  }

  async Login(request: LoginOktaRequest): Promise<LoginOktaResponse> {
    const response = await this.oktaApiClient.Login(request);
    return response;
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.oktaApiClient.GetApiUrl();
  }
}
